import { BaseQuestionnaireRoute } from '../slice';

type NonUsFinancialAccountsSubRoutes = {
  nonUsFinancialAccounts: BaseQuestionnaireRoute;
  accountsList: BaseQuestionnaireRoute;
};

export type NonUsFinancialAccountsRoutes = BaseQuestionnaireRoute &
  NonUsFinancialAccountsSubRoutes;

export const nonUsFinancialAccountsRoutes: {
  nonUsFinancialAccounts: NonUsFinancialAccountsRoutes;
} = {
  nonUsFinancialAccounts: {
    title: 'Non US Financial Accounts',
    path: 'nonUsFinancialAccounts',
    isValid: undefined,
    nonUsFinancialAccounts: {
      title: 'Non US Financial Accounts',
      path: 'nonUsFinancialAccounts',
      isValid: undefined,
    },
    accountsList: {
      title: 'Accounts List',
      path: 'accountsList',
      isValid: undefined,
    },
  },
};
